import * as React from 'react';
import CardList from './CardList';
import PromoCard from './PromoCard';

export const NewCompanyFeatureList = () => (
  <CardList className="animated fadeIn mv5">
    <PromoCard
      title="Stylized Brand View"
      subtitle="Filtru's new Discover tab features full sized screens
      inviting users to your brand click through to the website."
    />
    <PromoCard
      title="Reports"
      subtitle="See how your coffee is brewed and what audience it has.
      This includes territory, experience, and engagement."
    />
    <PromoCard
      title="Commerce"
      subtitle="Coming Soon."
    />
  </CardList>
);

export default NewCompanyFeatureList;
